import Vue from 'vue';

import './plugins/app';
import './plugins';
import { router } from './router';

import './components';
import './filters';
import './directives';
import './styles/main.scss';
import './styles/ckeditor/content-styles.css';
import store from './store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { AppFunctions } from './functions/AppFunctions';
import {
  deleteToken,
  isTokenValid,
  setTokenAnonymous,
  setTokenFromQuery,
} from './utils/token';
import { ref } from '@vue/composition-api';
import App from './App.vue';
import { AppStoreTypes } from './store/modules/app';
import { safeGetProp } from './utils/common';
import settings from './settings';

export let errorMessages = ref([]);

Vue.config.errorHandler = err => {
  console.log('Exception: ', err);
  errorMessages.value.push(err);
};

Vue.prototype.$placeholderImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcGg0AAcsBEuRzwtUAAAAASUVORK5CYII=';
Vue.prototype.$get = safeGetProp;
Vue.prototype.$goBackTo = function(to) {
  store.dispatch(AppStoreTypes.pageTransition.set, {
    value: {
      name: 'router-view-back',
      mode: '',
    },
  });
  router.push(to);
};
Vue.config.productionTip = true;
const _eventBus = new Vue();
export const eventBus = _eventBus;

let init = async () => {
  try {
    let isTokenSet = await setTokenFromQuery();
    let success = await setTokenAnonymous(isTokenSet);
    if (!success) {
      router.push({ name: 'NoPermission' });
      throw 'Nem sikerült a token beállítás';
    }
    if (isTokenValid()) {
      AppFunctions.GetInitData();
    } else {
      deleteToken();
    }
  } catch (error) {
    console.error('Hiba az initben', error);
  }
  new Vue({
    render: h => h(App),
    router,
    vuetify,
    store,
  }).$mount('#app');
};
init();
if (settings.isIframe) {
  window.parent.postMessage(
    'sn-url-change:' + encodeURIComponent('https://streamnext.hu'),
    '*'
  );
  addEventListener('beforeunload', event => {
    window.parent.postMessage(
      'sn-url-change:' + encodeURIComponent('https://other.com'),
      '*'
    );
  });
}
